// ============================================================
// billHistory.ts — (Follow-ups 29 Oct) delivery sentences for a bill's and a
// credit note's history (pure; billHistory.test.ts). Used by the bill
// screen's history (BillView histText) and the firm audit log
// (auditSentence), so both say the same thing:
//   POST  → "Marked as sent by post on 28 Oct 2026"
//   HAND  → "Marked as handed over on 28 Oct 2026"
//   EMAIL → "Emailed to ann@home.test on 28 Oct 2026"
// The date is the one the user gave (details.date, "YYYY-MM-DD") for post /
// hand, else when it was recorded (the audit row's createdAt) — in UK time.
// ============================================================

// "28 Oct 2026" — a "YYYY-MM-DD" is a calendar day (no time-zone shift);
// a timestamp is shown as its UK day.
export const historyDate = (v: unknown): string | null => {
  if (typeof v !== 'string' || !v) return null
  const ymd = /^\d{4}-\d{2}-\d{2}$/.test(v)
  const d = new Date(ymd ? `${v}T12:00:00Z` : v)
  return Number.isNaN(d.getTime()) ? null : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Europe/London' })
}

export const deliveryHistoryText = (method: unknown, opts: { date?: unknown; at?: unknown; to?: unknown; again?: boolean }): string => {
  const when = historyDate(opts.date) ?? historyDate(opts.at)
  const on = when ? ` on ${when}` : ''
  if (method === 'EMAIL') {
    const to = Array.isArray(opts.to) && opts.to.length ? (opts.to as unknown[]).map(String).join(', ') : 'the client'
    return `Emailed${opts.again ? ' again' : ''} to ${to}${on}`
  }
  return `Marked as ${method === 'HAND' ? 'handed over' : 'sent by post'}${on}`
}
